/** Closing portals remain in the DOM during their exit animation and no longer own keys. */
export function desktopInteractionOwnsKeys() {
  return [
    ...document.querySelectorAll<HTMLElement>(
      '[role="dialog"], [role="alertdialog"], [role="menu"], [role="listbox"]',
    ),
  ].some(
    (element) => element.getClientRects().length > 0 && !element.closest('[data-ending-style]'),
  );
}
